import { isNativePlatform } from "@/lib/capacitor";

export function getPaymentReturnUrl(
  paymentAttemptId: string,
  orderId: string,
): string {
  if (isNativePlatform()) {
    const url = new URL("com.muminsmart.app://payment/success");
    url.searchParams.set("paymentAttemptId", paymentAttemptId);
    url.searchParams.set("orderId", orderId);
    return url.toString();
  }

  const returnUrl = new URL("/payment/success", window.location.origin);
  returnUrl.searchParams.set("paymentAttemptId", paymentAttemptId);
  returnUrl.searchParams.set("orderId", orderId);
  return returnUrl.toString();
}
